import React, { useEffect, useState } from "react";
import useMediaQueries from "../../../../hooks/useMediaQueries.js";
import FilesActionGroup from "../../../Reusable/FilesActionGroup/FilesActionGroup.js";
import { useMail } from "../../../../contexts/mailContext/mailContext.js";
import { useMailView } from "../../../../contexts/mailViewContext/mailViewContext.js";
import useScrollTrigger from "../../../../hooks/useScrollTrigger.js";
import { useSideBar } from "../../../../contexts/sideBarContext/sideBarContext.js";
import Adsense from "../../../Reusable/Adsense/Adsense.js";
import Icon from "../../../Elements/Icon/Icon.tsx";
import AnimationContainer from "../../../Reusable/AnimationContainer/AnimationContainer.js";
import { useActionList } from "hooks/useActionList.js";
import useSelfRemovalLink from "hooks/useSelfRemovalLink.tsx";

const MobileFooter = () => {
  const { mobileCondition } = useMediaQueries();
  const { getSideBarContent } = useSideBar();
  const { moreThanNumber: adsShow, scrolledUp } = useScrollTrigger(
    window.innerHeight * 1.4
  );
  const {
    isMailAvailable,
    getIsDisplayAllowed,
    getMailStatus,
    getMailSecurity,
  } = useMail();
  const { moreThanNumber } = useScrollTrigger(100);
  const { getFilesSelection } = useMailView();
  const [showAllActions, setShowAllActions] = useState(false);

  useEffect(() => {
    const sideBar = document.querySelector(".side-bar-content");
    if (sideBar) {
      if (showAllActions) {
        sideBar.style = "margin-bottom: 90px";
      } else {
        sideBar.style = "";
      }
    }
  }, [showAllActions, getSideBarContent()]);

  const additioanActions = ["Comment", "Info", "Collection", "Security"];

  const isSelfRemove = useSelfRemovalLink();

  const statusActions = isSelfRemove
    ? ["DeleteMail"]
    : isMailAvailable() && getIsDisplayAllowed()
    ? getMailStatus() === "removed"
      ? ["ChangeMobileView", "Share"]
      : ["ChangeMobileView", "FolderStructure", "Share", "Save"]
    : ["Info"];

  const actionList = useActionList({
    defaultActionList: statusActions,
    security: getMailSecurity(),
  });

  const classes = getSideBarContent()
    ? " sidebar-open"
    : !moreThanNumber
    ? " hidden-mobile-footer"
    : "";

  return mobileCondition && getFilesSelection().length === 0 ? (
    <>
      {adsShow ? (
        <Adsense
          bannerPosition="download-bottom-sticky"
          stylePorps={getSideBarContent() ? { zIndex: 0 } : {}}
        />
      ) : null}
      <div
        className={
          `mobile-footer ${isMailAvailable() ? "" : "hide-footer-mobile"}` +
          classes
        }
      >
        <div className="main-action-container">
          <FilesActionGroup actionList={actionList} />
          <AnimationContainer
            animationOn={showAllActions}
            animationClassName="bottom-in"
          >
            <FilesActionGroup actionList={additioanActions} />
          </AnimationContainer>
        </div>
        {isSelfRemove ? null : (
          <div className="collapse-footer-actions">
            <Icon
              name="vertical-three-dots"
              gray
              onClick={() => {
                setShowAllActions((prev) => !prev);
              }}
            />
          </div>
        )}
      </div>
    </>
  ) : null;
};

export default MobileFooter;
